import { render, staticRenderFns } from "./homeDashboardStats.vue?vue&type=template&id=5839c471&scoped=true"
import script from "./homeDashboardStats.vue?vue&type=script&lang=js"
export * from "./homeDashboardStats.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardStats.vue?vue&type=style&index=0&id=5839c471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5839c471",
  null
  
)

export default component.exports